import React, { useRef, useState } from 'react';

interface MagnifierProps {
  src: string;
  alt: string;
  zoomLevel?: number;
  className?: string;
}

const Magnifier: React.FC<MagnifierProps> = ({
  src,
  alt,
  zoomLevel = 2,
  className = '',
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [backgroundPosition, setBackgroundPosition] = useState('center');
  const [isHovering, setIsHovering] = useState(false);

  const handleMouseMove = (e: React.MouseEvent) => {
    const { left, top, width, height } = containerRef.current!.getBoundingClientRect();
    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;
    setBackgroundPosition(`${x}% ${y}%`);
  };

  return (
    <div
      ref={containerRef}
      onMouseMove={handleMouseMove}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
      className={`relative ${className}`}
      style={{
        backgroundImage: `url(${src})`,
        backgroundSize: isHovering ? `${zoomLevel * 80}%` : 'cover',
        backgroundPosition: isHovering ? backgroundPosition : 'center',
        backgroundRepeat: 'no-repeat',
        width: '100%',
        height: '100%',
        cursor: 'none',
        borderRadius: '0.5rem',
      }}
    >
      {/* Imagine ascunsă doar pentru SEO și fallback */}
      <img
        src={src}
        alt={alt}
        className="w-full h-full opacity-0 object-contain"
        draggable={false}
      />
    </div>
  );
};

export default Magnifier;
